import InnerPay from './InnerPay.vue';
import utile from '../../utile';

export default {
  getComponentByConfig(config) {
    return utile.resetComponentByConfig(config, 'innerPay', InnerPay);
  },
};
